import { createReducer, on } from '@ngrx/store';
import {
  createErrorState,
  createLoadingState,
  createSuccessState,
} from 'app/store/app/app.models';
import {
  fetchMfaConfig,
  fetchMfaConfigFailure,
  fetchMfaConfigSuccess,
  saveMfaConfig,
  saveMfaConfigFailure,
  saveMfaConfigSuccess,
} from './mfa-config.actions';
import { IMfaConfigState, initialMfaConfigState } from './mfa-config.state';

export const mfaConfigReducer = createReducer(
  initialMfaConfigState,

  on(fetchMfaConfig, (state) => ({
    ...state,
    mfaConfig: createLoadingState(state.mfaConfig),
  })),

  on(fetchMfaConfigSuccess, (state, { mfaConfig }) => ({
    ...state,
    mfaConfig: createSuccessState(mfaConfig),
  })),

  on(fetchMfaConfigFailure, (state, { error }) => ({
    ...state,
    mfaConfig: createErrorState(error, null),
  })),

  on(saveMfaConfig, (state) => ({
    ...state,
    saveStatus: { loading: true, httpError: null, success: false },
  })),

  on(saveMfaConfigSuccess, (state) => ({
    ...state,
    saveStatus: { loading: false, httpError: null, success: true },
  })),

  on(saveMfaConfigFailure, (state, { error }) => ({
    ...state,
    saveStatus: { loading: false, httpError: error, success: false },
  }))
);
